/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useState, useEffect} from 'react'
import { getNameByISO3, shortenLargeNumber } from "../../../../libs/misc";
import Highcharts from 'highcharts/es-modules/masters/highcharts.src';
import "highcharts/es-modules/masters/highcharts-more.src"
import "highcharts/es-modules/masters/modules/exporting.src"
import "highcharts/es-modules/masters/modules/offline-exporting.src"
import "highcharts/es-modules/masters/modules/export-data.src"
import HighchartsReact from 'highcharts-react-official';
import { Spinner } from 'react-bootstrap';

type TradeHistoricalChartProps = {
  data?:any,
  hs:string,
  tradeflow:string
}

const TradeHistoricalChart:FC<TradeHistoricalChartProps> = ({
  data, hs, tradeflow
}) => {

  const [isLoading, setIsLoading] = useState(true)
  
  const highchartOptions = {
    chart:{
      zoomType: 'x',
      marginTop: 80,
      marginBottom: 100,
      height:500
    },
    tooltip: {
      headerFormat: '',
      useHTML: true,
      shared: true,
      crosshairs: true,
      formatter: function (this: any) {
        const points = this.points;
        points.sort(function(a, b) {
          return b.y - a.y; // Sort in ascending order, use b.y - a.y for descending
        });
        let tableRows = '';
        for (let i = 0; i < points?.length; i++) {
          const legendSymbol = points[i].series.legendItem.symbol.element.outerHTML;

          tableRows += `
            <tr>
              <td style="margin:0;padding:0">
                <svg height="16px" width="20px">
                  <svg x="2" y="-3">
                  ${legendSymbol}
                  </svg>
                </svg>
              </td>
              <td><b>${points[i].series.name}</b></td>
              <td>:</td>
              <td style="text-align: right;">
                ${new Intl.NumberFormat('en-US',{ 
                    style: 'currency', 
                    currency: 'USD',
                    maximumFractionDigits: 0
                  }).format(points[i].y)}
              </td>
            </tr>
          `;
        }
        
        var tooltip = `
          <div>
            <b>${this.x}</b>
            <table style="text-align: left">
              ${tableRows}
            </table>
          </div>
        `
        return tooltip;
      }
    },
    title:{
      text: data && data[0] 
        ? (tradeflow === 'exports' 
          ? `Historical Trade Patterns: Cambodia's Export Destinations of Commodity ${hs}` 
          : `Historical Trade Patterns: Cambodia's Import Sources of Commodity ${hs}`) 
        : 'No Data Found', // Default or loading title
        style: {
          fontSize: '16px'
        }
    },
    xAxis: [{
        crosshair: true,
        tickInterval: 1
      }],
    yAxis: [{
      labels: {
        formatter: function (this:any) { return shortenLargeNumber(this.value); },
      },
      title: {
        text: 'Value (USD)',
      }
    }],
    credits:{
      enabled: true,
      text: `Data source: UN Comtrade`,
      href: '#',
      position: {
        align: 'right'
      }
    },
    exporting: {
      enabled: true
    },
    plotOptions: {
        series: {
          connectNulls: true
        }
      },
      legend: {
        layout: 'horizontal',
        width: '100%',
        align: 'left',
        //x: 10,
        verticalAlign: 'bottom',
        floating: true,
        backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
      },
      series: []
  };

  const [chartOptions, setChartOptions] = useState(highchartOptions)
  
  // Cleanup function to reset the state when the component is unmounted 
  useEffect(()=>{
    setIsLoading(true)
    return () => {
      setIsLoading(true)
    };
  },[])

  useEffect(()=>{
    highchartOptions.series = data?.map(el=>{
      const lineName = getNameByISO3(Object.keys(el)[0])
      return{
        name: lineName,
        type: 'line',
        yAxis: 0,
        dashStyle: 'Solid',
        data: Object.values(el)[0],
        tooltip: { valueSuffix: ' US$' }
      }
    })
    setChartOptions(highchartOptions)
    setIsLoading(false)
  },[data])

  return (
    <>
    {!isLoading && (data?.length??0)>0 ? (
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        className='mt-5'
      />
    ):(
      <div className="d-flex align-items-center justify-content-center" style={{ height: '50vh' }}>
        <Spinner animation="border" role="status" variant="primary" className="me-3" />
        <div className="loading-text">
          Loading
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </div>
      </div>
    )}
    </>
  )
}

export {TradeHistoricalChart}